import { useRef, useEffect } from "react";
import { motion, useScroll, useTransform, useMotionValue, useSpring, useReducedMotion } from "framer-motion";

const TORUS = "https://static.prod-images.emergentagent.com/jobs/ec872f1e-40ea-45ab-a3c0-6329cc54fb21/images/0055383b01ba43095d7ba9864e385dde2483e701515d088ca8998fef3742cf54.jpeg";

// Aurevon hero visual — scroll parallax + mouse-follow, glassy torus on dark glow.
export default function AurevonHero({ className = "", src = TORUS, alt = "Aurevon brand visual, a glassy blue-green torus held in a crystalline glass hand glowing on black", mask = true, maxH = "96%" }) {
  const reduce = useReducedMotion();
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scrollY = useTransform(scrollYProgress, [0, 1], ["-6%", "8%"]);

  const mx = useMotionValue(0);
  const my = useMotionValue(0);
  const fx = useSpring(mx, { stiffness: 90, damping: 20, mass: 0.6 });
  const fy = useSpring(my, { stiffness: 90, damping: 20, mass: 0.6 });
  const rot = useTransform(fx, [-70, 70], [-5, 5]);

  const maskStyle = mask
    ? {
        WebkitMaskImage: "radial-gradient(ellipse 92% 88% at 50% 48%, #000 68%, transparent 100%)",
        maskImage: "radial-gradient(ellipse 92% 88% at 50% 48%, #000 68%, transparent 100%)",
      }
    : {};

  useEffect(() => {
    if (reduce) return;
    const onMove = (e) => {
      mx.set((e.clientX / window.innerWidth - 0.5) * 70);
      my.set((e.clientY / window.innerHeight - 0.5) * 50);
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, [mx, my, reduce]);

  return (
    <div ref={ref} className={className} data-testid="aurevon-hero-visual">
      <motion.div style={reduce ? undefined : { y: scrollY }} className="h-full w-full flex items-center justify-center">
        <motion.img
          src={src}
          alt={alt}
          style={reduce ? { maxHeight: maxH, ...maskStyle } : { x: fx, y: fy, rotate: rot, maxHeight: maxH, ...maskStyle }}
          initial={{ opacity: 0, scale: 1.06 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, margin: "-10%" }}
          transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
          className="max-w-full w-auto h-auto object-contain select-none will-change-transform"
          draggable="false"
        />
      </motion.div>
    </div>
  );
}
